export const OPEN_MODAL = 'MODAL/OPEN_MODAL';
export const CLOSE_MODAL = 'MODAL/CLOSE_MODAL';
